/**
 * @typedef {import("vuex").Commit} commit
 * @typedef {import("vuex").Dispatch} dispatch
 * @typedef {import("vuex").ActionContext} ActionContext
 * @typedef {Array<String>} NormalizationEntry
 * @typedef {Array<Number>}  D_CheckResponse
 */

import UploadResource from "../../../api/fileResource";
import RecordsResource from "../../../api/recordsResource";
import { ActivityTypes } from "../../../api/activityResource";

const uploadResource = new UploadResource();
const recordesource = new RecordsResource();

export default {
  reset_state({ commit }) {
    commit("RESET_STATE");
  },
  /**
   *
   * @param {ActionContext} param0
   */
  // eslint-disable-next-line no-unused-vars
  storeData({ commit, state }) {
    console.log(state);
  },
  /**
   *
   * @param {ActionContext} param0
   */
  cancelProgress({ commit }) {
    commit("RESET_STATE");
    return true;
  },
  /**
   *
   * @param {ActionContext} param0
   * @param {Data} data
   */
  setData({ commit }, data) {
    // console.log(data, typeof (data));
    const _data = data.map((x, i) => {
      x.$id = i;
      return x;
    });
    data.data = _data;
    commit("SET_DATA", data);
  },
  /**
   *
   * @param {ActionContext} param0
   * @param {Array<Cell>} data
   */
  updateEdiitingCells({ commit, state }, data) {
    const mutations = data.map((x) => x.$id);
    /**
     * @type {Array<Cell>}
     */
    const unChangedCells = state.editting.filter((x) => !mutations.includes(x.$id));

    const update = [...unChangedCells, ...data];

    commit("SET_EDITTING", update);
  },
  /**
   *
   * @param {ActionContext} param0
   * @param {Cell} data
   */
  updateEditingCell({ commit, state }, data) {
    let cell = state.editting.find((x) => x.$id === data.$id);
    const unChangedCells = state.editting.filter((x) => x.$id !== data.$id);

    cell = {
      ...cell,
      ...data,
    };

    unChangedCells.push(cell);
    unChangedCells.sort((a, b) => a.$id - b.$id);
    commit("SET_EDITTING", unChangedCells);
  },
  /**
   *
   * @param {ActionContext} param0
   * @param {Array<cacheNormalizationResponse>} data
   */
  cacheNormalizationResponse({ commit }, data) {
    // console.log(data)
    commit("SET_NORMALIZATION_RESPONSE", data);
    if (Array.isArray(data)) {
      const _state = data.length === 0;
      return commit("SET_NORMALIZATION_STATE", _state);
    }
    return commit("SET_NORMALIZATION_STATE", false);
  },
  /**
   *
   * @param {ActionContext} param0
   * @param {D_CheckResponse} data
   */
  cacheD_CHECK_Response({ commit }, data) {
    commit("SET_D_CHECK_RESPONSE", data);
    if (Array.isArray(data)) {
      const _state = data.length === 0;
      return commit("SET_DCHECK_STATE", _state);
    }
    return commit("SET_DCHECK_STATE", false);
  },
  /**
   *
   * @param {ActionContext} param0
   * @param {D_CheckResponse} data
   */
  cacheDB_CHECK_Response({ commit }, data) {
    commit("SET_DB_CHECK_RESPONSE", data);
    if (Array.isArray(data)) {
      const _state = data.length === 0;
      return commit("SET_DBCHECK_STATE", _state);
    }
    return commit("SET_DBCHECK_STATE", false);
  },
  /**
   *
   * @param {ActionContext} param0
   * @param {Array<Number>} cells
   */
  // eslint-disable-next-line no-unused-vars
  deleteCells({ commit, state }, cells) {
    return new Promise((resolve, reject) => {
      try {
        uploadResource
          .deleteCells(state.record.id, cells)
          // eslint-disable-next-line no-unused-vars
          .then(async (response) => {
            const updatedFile = await uploadResource.getOrdinaryData(state.record.id);
            /**
             * @TODO Decide if to delete current rows from record or reload file
             */
            const cells = updatedFile.data.map((x, i) => {
              x.$id = i;
              return x;
            });
            commit("SET_CELLS", cells);
            resolve(true);
          })
          .catch((e) => reject(e));
      } catch (error) {
        reject(error);
      }
    });
  },
  /**
   *
   * @param {ActionContext} param0
   * @param {Array<Number>} cells
   */
  // eslint-disable-next-line no-unused-vars
  push({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      uploadResource
        .push(state.record.id)
        .then(async () => {
          // Log data push activity
          dispatch(
            "activity/logActivity",
            {
              type: ActivityTypes.DATA_PUSHED,
              entityType: "data",
              entityId: state.record.id,
              entityName: state.record.filename || state.record.name,
              details: { fileId: state.record.id, fileName: state.record.filename },
            },
            { root: true }
          );

          resolve(true);
        })
        .catch((e) => reject(e));
    });
  },
  /**
   *
   * @param {ActionContext} param0
   */
  fetchRecords({ commit }) {
    return new Promise((resolve, reject) => {
      recordesource
        .getData()
        .then((records) => {
          console.log("gotten records", records);
          commit("SET_RECORDS", records.data.results);
          resolve(records.data);
        })
        .catch((e) => reject(e));
    });
  },
  /**
   *
   * @param {ActionContext} param0
   */
  fetchUploads({ commit }) {
    return new Promise((resolve, reject) => {
      uploadResource
        .list()
        .then((records) => {
          commit("SET_UPLOADS", records);
          resolve(records);
        })
        .catch((e) => reject(e));
    });
  },
  /**
   *
   * @param {ActionContext} param0
   */
  reset_upload_state({ commit, dispatch }) {
    dispatch("cacheD_CHECK_Response", null);
    dispatch("cacheDB_CHECK_Response", null);
    commit("RESET");
  },
};
